import { useState } from "react";
import { Play } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * VideoThumb — renders a JPG thumbnail generated server-side by ffmpeg.
 * Requires `clipId` to hit /api/clips/{id}/thumbnail. Falls back to a
 * warm gradient placeholder while loading or on failure.
 */
export default function VideoThumb({ clipId, className = "", iconSize = 12, showPlayBadge = true }) {
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <div className={`relative overflow-hidden bg-[#EAE6DF] ${className}`}>
      {clipId && !failed && (
        <img
          src={`${API}/clips/${clipId}/thumbnail`}
          alt=""
          loading="lazy"
          onLoad={() => setReady(true)}
          onError={() => setFailed(true)}
          className={`absolute inset-0 w-full h-full object-cover pointer-events-none transition-opacity duration-300 ${ready ? "opacity-100" : "opacity-0"}`}
        />
      )}
      {!ready && (
        <div className="absolute inset-0 bg-gradient-to-br from-[#8E9B82]/25 to-[#D4A373]/30 animate-pulse" />
      )}
      {showPlayBadge && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-6 h-6 rounded-full bg-black/55 backdrop-blur-sm flex items-center justify-center shadow-sm">
            <Play size={iconSize} className="text-white ml-0.5" fill="white" />
          </div>
        </div>
      )}
    </div>
  );
}
